export default "__VITE_ASSET__D7I7daW___"